// ------------------------------------
// Constants
// ------------------------------------
export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'

// ------------------------------------
// Actions
// ------------------------------------
export function showModal (modalType = 'none', modalProps = {}) {
  return {
    type: SHOW_MODAL,
    modalType,
    modalProps
  }
}

export function hideModal (modalType = 'none') {
  return {
    type: HIDE_MODAL,
    modalType
  }
}

export const actions = {
  showModal,
  hideModal
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SHOW_MODAL] : (state, action) => {
    const { modalType } = action
    return {
      ...state,
      [modalType] : {
        isModalOpen: true,
        modalType,
        modalProps: action.modalProps
      }
    }
  },
  [HIDE_MODAL] : (state, action) => {
    const { modalType } = action
    if (typeof modalType !== 'string') {
      return {
        ...state
      }
    }
    return {
      ...state,
      [modalType] : {
        isModalOpen: false,
        modalInfo: {
          modalType,
        }
      }
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
export default function modalReducer (state = {}, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/reducers/modal.js